<template>
  <v-list-item
    dense
    :class="cssClass"
    :style="cssStyle"
  >
    <span class="font-weight-medium me-2">{{ title }}:</span>
    <span
      v-if="!html"
      class="text--secondary"
    >{{ text }}</span>
    <span
      v-if="html"
      class="text--secondary"
      :inner-html.prop="text"
    ></span>
  </v-list-item>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
    html: {
      type: Boolean,
      default: false,
    },
    cssClass: { type: String, default: 'px-0 ma-20' },
    cssStyle: { type: String, default: null },
  },
  setup() {
  },
}
</script>
